import type { StaffCoordinationTechnicianV2Payload } from '@/types/apps/staff-coordination-technician-v2.type';
import type { ApiResponse } from '@/types/common/api.type';
import type { BaseApiClientInterface } from '@/types/service/base-api-client.interface';
import type { Creatable } from '@/types/service/creatable.interface';

export class StaffCoordinationTechnicianV2Service implements Creatable {
    public constructor(private apiClient: BaseApiClientInterface) {}

    protected endpoints = {
        base: () => '/api/v2/staff-coordination',
    };

    public create(
        params: StaffCoordinationTechnicianV2Payload
    ): Promise<ApiResponse<{ id: string }>> {
        return this.apiClient.postApi(this.endpoints.base(), params);
    }
}
